import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';

export default function AorgMarkdown(props: {
  content: string;
  class?: string;
}) {
  function LinkRenderer(props: any) {
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  }

  function StrongRenderer(props: any) {
    return (
      <strong className="text-white font-semibold">{props.children}</strong>
    );
  }

  return (
    <ReactMarkdown
      className={classNames(
        'text-white prose prose-headings:text-white prose-a:text-white ',
        ...(props.class ?? '')
      )}
      components={{ a: LinkRenderer, strong: StrongRenderer }}
    >
      {props.content}
    </ReactMarkdown>
  );
}
